/* ============================================================
   pp-our-process.js
   Motion graphic for "Our Process" timeline section.
   Supports multiple instances on the same page.
   8s loop: steps fade+rise in, track fills, badges pop.
   Respects prefers-reduced-motion (holds final frame).
   ============================================================ */
(function () {
  var DUR  = 12000;
  var ACT  = [0.10, 0.30, 0.50];
  var RAMP = 0.17;
  var LINE_A = 0.07, LINE_B = 0.62;
  var OUT_A  = 0.86, OUT_B  = 0.985;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function clamp01(x) { return x < 0 ? 0 : x > 1 ? 1 : x; }
  function easeOutCubic(x)    { return 1 - Math.pow(1 - x, 3); }
  function easeInOutCubic(x)  { return x < 0.5 ? 4*x*x*x : 1 - Math.pow(-2*x+2,3)/2; }
  function easeOutBack(x) {
    var c1 = 1.70158, c3 = c1 + 1;
    return 1 + c3*Math.pow(x-1,3) + c1*Math.pow(x-1,2);
  }

  function initProcess(wrap) {
    var steps = Array.prototype.slice.call(wrap.querySelectorAll('.pp-proc-step'));
    var fill  = wrap.querySelector('.pp-proc-fill');
    var track = fill && fill.parentElement;
    if (!steps.length || !fill) return;

    fill.style.setProperty('--p', '0');

    var nodes = steps.map(function(st) {
      return {
        st:    st,
        badge: st.querySelector('.pp-proc-badge'),
        disc:  st.querySelector('.pp-proc-disc')
      };
    });

    function apply(t) {
      var fade = t < OUT_A ? 1 : 1 - clamp01((t - OUT_A) / (OUT_B - OUT_A));
      var lp   = easeInOutCubic(clamp01((t - LINE_A) / (LINE_B - LINE_A)));
      fill.style.setProperty('--p', lp.toFixed(4));
      if (track) track.style.opacity = (t < OUT_A ? 1 : fade).toFixed(3);

      nodes.forEach(function(n, i) {
        var a   = clamp01((t - ACT[i]) / RAMP);
        var aE  = easeOutCubic(a);
        // keep text static (no motion)
        n.st.style.opacity = (fade).toFixed(3);
        // animate ONLY icons
        var pop = a <= 0 ? 0 : easeOutBack(a);
        n.badge.style.transform = 'scale(' + (0.64 + pop * 0.36).toFixed(3) + ')';
        n.disc.style.transform = 'scale(' + aE.toFixed(3) + ')';
        var pop = a <= 0 ? 0 : easeOutBack(a);
        n.badge.style.transform = 'scale(' + (0.64 + pop * 0.36).toFixed(3) + ')';
        n.disc.style.transform  = 'scale(' + aE.toFixed(3) + ')';
      });
    }

    if (reduce) { apply(0.8); return; }

    var start = null;
    function frame(now) {
      if (start === null) start = now;
      apply(((now - start) % DUR) / DUR);
      requestAnimationFrame(frame);
    }
    requestAnimationFrame(frame);
  }

  function boot() {
    var wraps = document.querySelectorAll('.pp-process[data-pp-process]');
    for (var i = 0; i < wraps.length; i++) { initProcess(wraps[i]); }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
